<div class="skeleton-wrapper">
  <label class="skeleton-label"></label>
  <div class="skeleton-select"></div>
</div>
